:host{
  /* Size */
  --border-radius:var(--jb-popover-border-radius, var(--jb-radius-xl));
  /*padding also affect fixed position item (positioned by js in bindTarget)*/
  --margin-top:var(--jb-popover-margin-top,0);
  --inset-block-start: var(--jb-popover-top, 0);
  --padding: var(--jb-popover-padding, 1rem);
  /* Theme/Color */
  --back-bg-color:var(--jb-popover-back-bg-color, oklch(from var(--jb-surface-inverse) l c h / 0.5));
  --bg-color:var(--jb-popover-bg-color, #fff);
  /* Other */
  --z-index: var(--jb-popover-z-index, 10);
  --box-shadow: var(--jb-popover-box-shadow,
    0.75rem 0.75rem 1rem 0 rgba(0, 0, 0, 0.25),
    -0.5rem -0.5rem 0.75rem 0 rgba(255, 255, 255, 0.3));
}
